import Stack from 'react-bootstrap/Stack'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'

import { formatCardDescription } from './utils'

export function CustomerPaymentMethodsTable({
  savedPaymentMethods = [],
  processingPaymentMethodId = '',
  preventLastPaymentMethod = false,
  onSetDefault,
  onUpdateCard,
  onRemoveCard,
}) {
  const hasOnlyOneMethod = savedPaymentMethods.length <= 1

  return (
    <div className="table-container">
      <Table responsive className="mb-0">
        <thead>
          <tr className="md md--scroll">
            <th className="text-left uppercase text-body">Card</th>
            <th className="text-left uppercase text-body">Expires</th>
            <th className="text-left uppercase text-body">Status</th>
            <th className="text-left uppercase text-body">Actions</th>
          </tr>
        </thead>
        <tbody>
          {savedPaymentMethods.map((method) => {
            const methodId = method?.id
            const isDefault = Boolean(method?.isDefault)
            const isBusy = processingPaymentMethodId === methodId
            const removeDisabled =
              (preventLastPaymentMethod && hasOnlyOneMethod) || isBusy

            return (
              <tr className="md-x md-x--scroll" key={methodId}>
                <td className="text-left">
                  {formatCardDescription(method?.card)}
                </td>
                <td className="text-left">
                  {method?.card?.exp_month?.toString().padStart(2, '0')}/
                  {method?.card?.exp_year}
                </td>
                <td className="text-left">
                  {isDefault ? (
                    <Badge
                      bg="none"
                      className="badge-sm badge--active w-max-content"
                    >
                      Default
                    </Badge>
                  ) : (
                    <span className="text-muted">Saved</span>
                  )}
                </td>
                <td className="text-left">
                  <Stack direction="horizontal" gap={2} className="flex-wrap">
                    {!isDefault ? (
                      <Button
                        variant="outline-light"
                        size="sm"
                        disabled={isBusy}
                        onClick={() => onSetDefault(methodId)}
                      >
                        Set default
                      </Button>
                    ) : null}
                    <Button
                      variant="outline-light"
                      size="sm"
                      disabled={isBusy}
                      onClick={() => onUpdateCard(methodId)}
                    >
                      Update card
                    </Button>
                    <Button
                      variant="outline-light"
                      size="sm"
                      disabled={removeDisabled}
                      onClick={() => onRemoveCard(methodId)}
                    >
                      Remove
                    </Button>
                  </Stack>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}
